import React from "react";
import { useTranslation } from "react-i18next";

function CopyRight() {
  const {t ,i18n} = useTranslation()
  return (
    <div className="footer_bottom">
      <div className="container">
        <p className={`mb-0 fz12  ${i18n.dir() === "rtl" ? "Almaraisemibold" : "poppinsregular"}`}>
          {t("Copyright")}
        </p>
      </div>
    </div>
  );
}

export default CopyRight;
